module.exports = __webpack_public_path__ + "img/interaktive_grafik.ea438a01.svg";